import { centsToDollars, dollarsToCents } from '@b-stock/fe-core/bstock-react'

import type { Range } from '@/components/listings/search/SearchFilters/shared/commonTypes'
import { createCurrencyRangeAppliedComponent } from '@/components/listings/search/SearchFilters/shared/filterUtils'
import CurrencyCentsRangeFilter from '@/components/listings/search/SearchFilters/shared/NumericRangeFilter/CurrencyCentsRangeFilter'
import type {
  ListingFilter,
  FilterProps,
} from '@/components/listings/search/SearchFilters/types'

const MsrpFilter: ListingFilter<Range> = ({
  onChange,
  desktopScreen,
  value,
  onError,
}: FilterProps<Range>) => {
  return (
    <CurrencyCentsRangeFilter
      selected={[
        value[0] ? dollarsToCents(value[0]) : null,
        value[1] ? dollarsToCents(value[1]) : null,
      ]}
      onChange={(value) => {
        const converted: Range = [
          value[0] ? centsToDollars(value[0]) : null,
          value[1] ? centsToDollars(value[1]) : null,
        ]
        onChange(converted)
      }}
      onError={onError}
      currency="USD"
      desktopScreen={desktopScreen}
      analyticsTitle="MSRP"
    />
  )
}

MsrpFilter.expandedOnInit = false
MsrpFilter.getOwnProps = ({ state, updateFilters }) => ({
  filterKey: 'msrp',
  onChange: (msrp: Range) => {
    updateFilters({ msrp })
  },
  value: state.filters.msrp,
})

MsrpFilter.label = 'Filters.msrp'

MsrpFilter.Applied = createCurrencyRangeAppliedComponent(
  'msrp',
  MsrpFilter.label,
  'USD'
)

export default MsrpFilter
